// import React, { useEffect, useState } from 'react'
// import { sitePolicy } from '../asiosConfig';
// import { toast } from 'react-toastify';
// import { Box, Container, Paper, Skeleton, Typography } from '@mui/material';
// import Nav from './Nav';
// import Navbar from './Navbar';
// import Footer from './Footer';
// export const TermOfUse = () => {
//     const [term, setTerm] = useState({});
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchAboutUs = async () => {
//             try {
//                 const response = await sitePolicy();
//                 if (response.status === 200 || response.status === 201) {
//                     setTerm(response.data.data);

//                 } else {
//                     toast.error('Failed to fetch about us data');
//                 }
//             } catch (error) {
//                 toast.error('Failed to fetch about us data');
//             } finally {
//                 setLoading(false);
//             }
//         }; 
//         fetchAboutUs();
//     }, []);
//     return (
//         <Box>
//             <Navbar />
//             <Box mt={12}>
//                 <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//                     <Paper elevation={6} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
//                         <Box textAlign="center" mb={12} mt={5}>
//                             {loading ? (
//                                 <>
//                                     <Skeleton variant='text' width='50%' height={40} sx={{ mx: 'auto', mb: 3 }} />

//                                     <Skeleton variant='rectangular' width="100%" height={200} sx={{ mb: 4 }} />
//                                     {/* <Skeleton variant='rectangular' width="100%" height={200} sx={{ mb: 4 }} /> */}
//                                 </>
//                             ) : (
//                                 <>
//                                     <Typography
//                                         variant="h4"
//                                         component="h3"
//                                         gutterBottom
//                                         sx={{
//     fontFamily: "Montserrat",


//     hyphens: "auto",               // Optional: adds hyphens for better readability
//     textAlign: "center",           // Ensures centering works
//     width: "100%",                 // Forces it to respect container width
//     maxWidth: "100%",              // Critical for preventing overflow
//     boxSizing: "border-box",       // Safe padding/margin handling
//     px: { xs: 0, sm: 0 },          
//     fontSize: { xs: "1.8rem", sm: "2.125rem" },
//   }}
//                                     >
//                                         IND Matrimony Terms Of Use
//                                     </Typography>
//                                     <br />
//                                     <div className='text-left' style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: term.terms_of_use }} />
//                                 </>
//                             )}
//                         </Box>
//                     </Paper>
//                 </Container>
//             </Box>
//             <Footer />
//         </Box>
//     )
// }












import PolicyLayout from "./PolicyLayout";

export const TermOfUse = () => {
  return (
    <PolicyLayout
      title="Terms &"
      highlightText="Conditions"
      subtitle="Welcome to IND Matrimony. By accessing or using our website, mobile app, or services, you agree to the following Terms & Conditions."
      lastUpdated="12 November 2025"
      dataKey="terms_of_use"
    />
  );
};
